export class ExpertServiceFeatures{
  static readonly FirmAdmin = 'MPFirmAdmin';
  static readonly Consultant = "MPFirmConsultant";
  static readonly Member = "Is not done yet";
}
